/**
 * Значки разделов. Рисованные, в одну линию, цвет — от текста.
 * Внешние наборы значков не подключаются: политика безопасности
 * разрешает загрузку только с собственного сервера.
 */
const PATHS = {
  // Дашборд — четыре окна разного размера
  dashboard: 'M3 3h6v8H3zM11 3h6v4h-6zM11 9h6v8h-6zM3 13h6v4H3z',
  // Объекты — магазин с навесом
  objects: 'M3 8l1.5-4h11L17 8M3 8v9h14V8M3 8h14M8 17v-5h4v5',
  // Дубли — две наложенные карточки
  dupes: 'M7 7h10v10H7zM3 13V3h10',
  // Дивизионы — карта из трёх частей
  divisions: 'M3 5l4.5-2 5 2L17 3v12l-4.5 2-5-2L3 17zM7.5 3v12M12.5 5v12',
  // Оборудование — корпус с индикаторами
  equipment: 'M3 6h14v8H3zM6 10h.01M9 10h.01M12 10h3',
  // Шкафы — стойка с полками
  racks: 'M5 2h10v16H5zM5 7h10M5 12h10M8 4.5h4M8 9.5h4M8 14.5h4',
  // Порты — гнездо RJ45
  ports: 'M4 5h12v9h-3v2H7v-2H4zM7 8v2M10 8v2M13 8v2',
  // Отправка в NetBox — стрелка вверх в лоток
  netbox: 'M10 13V3M6 7l4-4 4 4M3 12v5h14v-5',
  // Поиск
  search: 'M8.5 15a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13zM13.5 13.5L18 18',
  // Меню
  menu: 'M3 6h14M3 10h14M3 14h14',
  // Загрузка в приложение
  upload: 'M10 13V3M6 7l4-4 4 4M4 13v4h12v-4',
  // Документ
  document: 'M5 2h7l3 3v13H5zM12 2v3h3M8 10h4M8 13h4',
  // Раскрыть вниз
  chevron: 'M5.5 8l4.5 4.5L14.5 8',
  // Закрыть
  close: 'M5 5l10 10M15 5L5 15',
};

export default function Icon({ name, size = 20, className }) {
  const d = PATHS[name];
  if (!d) return null;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={d} />
    </svg>
  );
}
